<template>
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-12">
                <div class='chart-row'>
                    <div id="leads-day-of-week" class='chart-column'></div>
                    <div id="calls-day-of-week" class='chart-column'></div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'activeTab',
        ],
        watch: {
            data() {
                this.refresh();
            },
            activeTab() {
                if (this.activeTab == 'day-of-week') this.refresh();
            }
        },
        methods: {
            refresh() {
                this.drawLeadsChart();
                this.drawCallsChart();
            },
            drawLeadsChart() {
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Day of Week', '# Leads']],
                        _.map(this.data.dayOfWeek, (value, key) => [ key, parseInt(value) ])
                    )
                );
                var options = {
                    title: 'Leads',
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('leads-day-of-week'));
                chart.draw(data, options);
            },
            drawCallsChart() {
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Day of Week', '# Calls']],
                        _.map(this.data.callsDayOfWeek, (value, key) => [ key, parseInt(value) ])
                    )
                );
                var options = {
                    title: 'Calls',
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('calls-day-of-week'));
                chart.draw(data, options);
            },
        },
    }
</script>

<style scoped>
    .chart-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width: 100%;
    }
    .chart-column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        min-height: 40em;
    }    
</style>
